import { Button } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import theme from './theme';

const {
  colors: { background, numberColor },
} = theme;

const Info = ({ from, nombre, subTitle, title }) => {
  const { classes } = useStyles(styles);

  const { push } = useHistory();

  const goToStudentCandidate = () => {
    push(ROUTES_PATH.STUDENT_CANDIDATURES, {
      from,
    });
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <FormattedMessage id={title} />
      </div>
      <div className={classes.notify}>
        <div className={classes.subTitle}>
          <FormattedMessage id={subTitle} />
        </div>
        <Button className={classes.nombre} onClick={goToStudentCandidate}>
          {nombre}
        </Button>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: spacing(2.5, 2.5, 1.5, 2.5),
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%'
  },
  title: {
    marginTop: spacing(0.5),
    fontWeight: 600,
    color: '#152652',
    fontFamily: 'Montserrat',
    '@media only screen and (max-width:1920px)': {fontSize: '15.00px'},
    '@media only screen and (max-width:1600px)': {fontSize: '13.500px'},
  },
  notify: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: spacing(1),
    alignItems: 'center'
  },
  subTitle: {
    color: '#5D75A8',
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'},
    '@media only screen and (max-width:1600px)': {fontSize: '14px'},
  },
  nombre: {
    padding: 0,
    minWidth: 0,
    fontWeight: 400,
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'},
    '@media only screen and (max-width:1600px)': {fontSize: '14px'},
    border: 'none',
    '& > *': {
      color: numberColor,
    },
    '&:hover': {
      border: 'none',
      backgroundColor: 'white',
      '& > *': {
        fontWeight: 600,
      },
    },
  },
});

Info.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  nombre: PropTypes.number,
  from: PropTypes.string,
};

export default Info;
